import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { t } from 'src/shared/literals';

import Datatable from '../../../shared/ui/components/Datatable';
import getContractList from 'src/contract/use-cases/getContractList';

const ContractDatatable = ({ customerId, handleEdit, handleAdd }) => {
  const [list, setList] = useState({
    rows: [],
    count: 0
  });
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [orderBy, setOrderBy] = useState({
    columnName: null,
    orderBy: null
  });

  const navigate = useNavigate();

  const fetchList = async () => {
    const response = await getContractList({
      customerId,
      search: search,
      orderBy: orderBy.columnName
        ? `${orderBy.columnName} ${orderBy.orderBy}`
        : '',
      page,
      limit
    });

    response.rows = response.rows.map((x) => {
      let MoneyCollectionCustomerContactPaymentTypeList = {
        MoneyCollectionCustomerContactPaymentTypeList: x
          .MoneyCollectionCustomerContact.PaymentTypeList
          ? x.MoneyCollectionCustomerContact.PaymentTypeList.map((y) =>
              t(y.toLowerCase()).toUpperCase()
            ).join(',')
          : ''
      };

      return {
        ...x,
        ...MoneyCollectionCustomerContactPaymentTypeList
      };
    });

    setList(response);
  };

  useEffect(() => {
    fetchList();
  }, [page, limit, search, orderBy]);

  const handleSearch = (searchValue) => {
    setPage(0);
    setSearch(searchValue.target.value);
  };

  const handleChangePage = (pageIndex) => {
    setPage(pageIndex);
  };

  const handleChangeLimit = (limitIndex) => {
    setLimit(limitIndex);
  };

  const handleOrderBy = (column) => {
    setOrderBy(column);
  };
  const handleClickEdit = (event, id) => {
    handleEdit(id);
  };

  const handleClickAdd = (event) => {
    handleAdd();
  };

  const columnNameList = [
    'createdAt',
    'updatedAt',
    'ContractStatus.code',
    'hasPendingDocuments',
    '${contractCodePrefix}${contractCode}',
    'billToCustomerContactDocument',
    'MoneyCollectionCustomerContact.document',
    'MoneyCollectionCustomerContactPaymentTypeList',
    '${Seller.firstname}${Seller.surnames}',
    'contractTypeSellerComission',
    'contractTypeReferralComission',
    'UnmanagedSignaturePenaltyFee',
    'ContractType.name',
    'itemName',
    'identification',
    'document',
    'beginDate',
    'renewalDate',
    '${UserCreator.firstname}${UserCreator.surnames}',
    'comments'
  ];

  return (
    <Datatable
      domainName="CUSTOMER_CONTRACT"
      dataList={list.rows}
      count={list.count}
      addButtonText="Añadir contrato"
      addButtonRoute={false}
      title="Contratos"
      exportExcelButton={Boolean(false)}
      onSearch={handleSearch}
      onChangePageValue={handleChangePage}
      onChangePageLimit={handleChangeLimit}
      handleOrderBy={handleOrderBy}
      handleClickAdd={handleClickAdd}
      handleClickEdit={handleClickEdit}
      columnNameList={columnNameList}
    />
  );
};

export default ContractDatatable;
